<template>
  <div>
    <div>
      <RawJsonToggler :json="task" />
      <!-- Task -->
      <h1>{{ task.taskDefName }}</h1>
      <!-- Actions -->
      <Fieldset legend="Actions">
        <router-link
          tag="button"
          :to="{
            name: 'workflow',
            label: 'Workflow',
            params: { workflowId: task.workflowInstanceId }
          }"
        >
          Workflow
        </router-link>
        <router-link
          v-if="task.taskType == 'SUB_WORKFLOW'"
          tag="button"
          :to="{
            name: 'workflow',
            params: { workflowId: task.outputData.subWorkflowId }
          }"
        >
          Sub Workflow
        </router-link>
        <router-link
          tag="button"
          :to="{ name: 'taskResultEdit', params: { taskId: taskId } }"
        >
          Update
        </router-link>
      </Fieldset>
      <DataList :data="task" :attributes="attributes" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DataList from '@/components/DataList.vue'
import Fieldset from '@/components/Fieldset.vue'
import RawJsonToggler from '@/components/RawJsonToggler.vue'

export default {
  name: 'Task',
  props: ['taskId'],
  data() {
    return {
      attributes: [
        { name: 'executed', type: 'boolean' },
        { name: 'taskType', type: 'text' },
        { name: 'status', type: 'text' },
        { name: 'workflowType', type: 'text' },
        { name: 'workflowInstanceId', type: 'text' },
        { name: 'scheduledTime', type: 'date' },
        { name: 'queueWaitTime', type: 'duration' },
        { name: 'startTime', type: 'date' },
        { name: 'updateTime', type: 'date' },
        { name: 'endTime', type: 'date' },
        { name: 'reasonForIncompletion', type: 'text' }
      ]
    }
  },
  computed: mapState(['task']),
  methods: mapActions(['getTask']),
  created() {
    this.getTask(this.taskId)
  },
  watch: {
    taskId: function() {
      this.getTask(this.taskId)
    }
  },
  components: {
    DataList,
    Fieldset,
    RawJsonToggler
  }
}
</script>
